var isPrototypeOf = require('../../internals/object-is-prototype-of');
var method = require('../array/virtual/map');

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.map;
  return it === ArrayPrototype || (isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.map) ? method : own;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/instance/map.js
// module id = 401
// module chunks = 0 1